import { Typography } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './style.module.css';

const { Title, Paragraph } = Typography;

const GreetingsInfo: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <img
        src="/img/hero-1920.jpg"
        srcSet="/img/hero-960.jpg 960w, /img/hero-1920.jpg 1920w"
        sizes="100vw"
        width={1920}
        height={1080}
        alt={t('greetingsInfo.title')}
        className={styles.image}
        fetchPriority="high"
      />
      <div className={styles.overlay}>
        <Title level={2} className={styles.title}>
          {t('greetingsInfo.subtitle')}
        </Title>
        <Title level={1} className={styles.mainTitle}>
          {t('greetingsInfo.title')}
        </Title>
        <Paragraph className={styles.text}>{t('greetingsInfo.tagline')}</Paragraph>
      </div>
    </div>
  );
};

export default GreetingsInfo;
